import {
  FC,
  forwardRef,
} from 'react';
import "./filed.scss";
 
// interface to declare all our prop types
export type InputProps = {
  id?: string, // default, primary, info, success, warning, danger, dark
  name?: string, // sm, md, lg
  disabled?: boolean;
  size?: string, //
  type?: string,
  placeholder?: string;
  onChange?: any
  defaultValue?:any;
  value?:any;
  maxLength?:number;
  pattern?:string;
}

export const Fields: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  ({
    children,
    id = 'id',
    name = 'name',
    size = '',
    type = '',
    value,
    placeholder = '',
    defaultValue,
    maxLength,
    pattern,
    disabled,
    onChange,
    ...rest
  }, ref) => {
    return (
      <input
        className={`field ${size}`}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        defaultValue = {defaultValue}
        ref={ref}
        value={value}
        disabled={disabled}
        onChange={onChange}
        maxLength = {maxLength}
        pattern = {pattern}
        onWheel={(e) => e.currentTarget.blur()}
      {...rest}
      />
    );
  }
)

export default Fields;
